module.exports = __webpack_public_path__ + "startpage-746fed5a/das-ultimative-handbuch-fuer-empfeh-bc75c8f73298fbdcddc6791559824c24.jpeg";